import { Box, Button, CircularProgress } from '@mui/material';

interface LoadMoreButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  hasMore: boolean;
}

export const LoadMoreButton = ({ onClick, isLoading, hasMore }: LoadMoreButtonProps) => {
  if (!hasMore) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
      <Button variant='text' size='small' onClick={onClick} disabled={isLoading} sx={{ textTransform: 'none' }}>
        {isLoading ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
        Load more...
      </Button>
    </Box>
  );
};
